<div
  #optionContainer
  [attr.aria-selected]="selected"
  [class.focused]="focused"
  [class.multiple]="multiple"
  [class.visible]="visible"
  [id]="id"
  role="option"
  (click)="select.emit(!selected)"
>
  <opac-checkbox *ngIf="multiple" [checked]="selected"></opac-checkbox>

  <span>
    <ng-content></ng-content>
  </span>

  <opac-icon *ngIf="!multiple" icon="check"></opac-icon>
</div>
